"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sortNavConfig;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

function sortNavConfig(config) {
  return (0, _toConsumableArray2.default)(config).sort(function (a, b) {
    return a.label.localeCompare(b.label);
  }).map(function (configSection) {
    var newSection = (0, _extends2.default)({}, configSection);

    if (configSection.children && configSection.children.length > 0) {
      newSection.children = sortNavConfig(configSection.children);
    }

    return newSection;
  });
}

module.exports = exports.default;